import { z } from 'zod';

export const perfilSchema = z.object({
  nomeFantasia: z.string().optional(),
  nomeEmpresa: z.string().optional(),
  cnpj: z.string().optional(),
  telefone: z.string().optional(),
  endereco: z.string().optional(),
  logoUrl: z.string().optional(),
  pixKey: z.string().optional(),
  fundoDeTroco: z.number().optional(),
});

export type PerfilInput = z.infer<typeof perfilSchema>;
export type Perfil = PerfilInput;

export const restaurarContaSchema = z.object({
  email: z.string().email('E-mail inválido'),
  senha: z.string().min(1, 'Senha é obrigatória'),
});

export type RestaurarContaInput = z.infer<typeof restaurarContaSchema>;

